import { Dropdown } from "primereact/dropdown";
import { classNames } from "primereact/utils";
import { useEffect} from "react"
import { useDispatch, useSelector } from "react-redux"
import { useNavigate } from "react-router";
import { AppToast } from "../../lib/toast";
import { initTenantList,switchTenant } from "../../store/tenant/tenantSlice";
import { handleLoginResponse } from "../login/loginResponseHandler";
import { slbEventBus } from "../../lib/SearchLego/searchlego.eventbus.min";
import { setPageLoader } from "../../store/loader/loaderSlice";
import { getGaiConfig } from "../../store/gai/gaiSlice";
import { getChartConfig } from "../../store/charts/chartSlice";


export function TenantSeletor(props) {
    const dispatch = useDispatch();
    const navigate = useNavigate()
    const tenantList = useSelector(x => x.tenant.tenantList);
    const selectedTenant = useSelector(x => x.tenant.currentTenant);
    useEffect(() => {
        if(!Array.isArray(tenantList) || tenantList.length < 1)
             dispatch(initTenantList())
    }, [])
    
    let tenantId
    const switchTenant_Fn = (tenant) => {
        tenantId = tenant.tenantId;
        localStorage.removeItem('tabsSelected')
        localStorage.removeItem('proximity_search_enabled')
        localStorage.removeItem('fuzzy_search_enabled')
        dispatch(setPageLoader(true))
        Promise.all([dispatch(getChartConfig({
            tenantId: tenant.tenantId
        })),dispatch(getGaiConfig({
            tenantId: tenant.tenantId
        })),
        dispatch(switchTenant({
            tenantId: tenant.tenantId
        }))]).then(([chart,gai,res]) => {
            window.slbConfig.accountId = tenantId; 
            window.slbConfig.projectId = "0";
            window.slbConfig.gaiConfig = gai.payload?.data || {};
            //window.slbConfig.hostUrl = data.hostUrl; 
            slbEventBus.emit('refreshConfig', {imprint: '', slbConfig: window.slbConfig})
            
            // dispatch(setUserAuth(res.payload.data))
            // dispatch(setCurrentTenant(tenant))
            // navigate('/documents', { replace: true })
            dispatch(setPageLoader(false))
            handleLoginResponse(res.payload, navigate, dispatch)
        }).catch((error) => {
            debugger
            AppToast.Toast.error({title: 'Tenant switch failed.'})
        })
    }

    return <>
            {/* <label>Tenant</label> */}
        <Dropdown 
            dropdownIcon="fa fa-caret-down" id={'tenant'}
            className={classNames({ 'p-invalid': false })}
             optionLabel={'tenantName'}
            value={selectedTenant} appendTo={'self'}
            onChange={(e) => switchTenant_Fn(e.value)} options={tenantList || []} />
    </>
}